export interface TenantList {
    isSelected?: boolean;
    companyName?: string;
    companyUrl?: string;
    tenantName?: string;
    address?: string;
    email?: string;
    telephone?: number;
    id?: string;
    action?: string;
}

export interface tenantResponse {
    created?: {
        createdBy?: string;
        createdTime?: number;
    };
    defaultitemPerpage?: number;
    extention: any,
    general?: GeneralTab;
    id?: string;
    local?: LocalTab;
    mail?: EmailTab;
    smtpId?: string;
    subTenants?: string[];
    updated?: {
        updatedBy?: string;
        updatedTime?: number;
    }[];
    _id?: string;
}

export interface TenantPayload {
    id?: string;
    general?: GeneralTab;
    local?: LocalTab;
    mail?: EmailTab;
    smtpId?: string[];
    defaultitemPerpage?: number;
    created?: {
        createdBy?: string;
        createdTime?: number;
    };
    updated?: {
        updatedBy?: string;
        updatedTime?: number;
    }[];
}

export interface GeneralTab {
    countryUrl?: string;
    tenantName?: string;
    SubTenantName?: string;
    userNameId?: string;
    storeTypeId?: string;
    address?: string;
    email?: string;
    telephone?: number;
}

export interface LocalTab {
    countryId?: string;
    stateId?: string;
    languageId?: string;
}

export interface EmailTab {
    id?: string;
    hostname?: string;
    username?: string;
    password?: string;
    port?: string;
    name?: string;
    secure?: boolean;
    timeout?: string;
    type?: string;
    tenantId?: string;
    status?: boolean;
    createdId?: string;
}

export class TenantNode {
    children?: TenantNode[];
    item: string;
    value: string;
    label: string;
    level: number;
    expandable: boolean;
    isSelected?: boolean;
}

export class SubTenantNode {
    item: string;
    value: string;
    label: string;
    level: number;
    expandable: boolean;
    isSelected?: boolean
}

export interface GetAllTenantSubTenant {
    id: string;
    tenentName: string;
    _id: string;
    subTenants: GetAttechedSubTenant[];
}

export interface GetAttechedSubTenant {
    SubTenantName?: string;
    id?: string;
    _id?: string;
    name?: string;
}
